import React from 'react'
import Async from 'react-promise'
import PageLoader from 'components/PageLoader'
import { signInUri } from 'utils/unifiedLogin'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getSessionStatus, postSessionBypass } from 'utils/api'

class EnsureULSession extends React.Component {
  render() {
    const { children } = this.props
    return (
      <Async
        promise={getSessionStatus()}
        pending={() => <PageLoader />}
        then={() => children}
        catch={() =>
          window.top.location.replace(
            signInUri(
              `${
                window.parent.location !== window.location
                  ? document.referrer
                  : document.location.href
              }`
            )
          ) || null
        }
      />
    )
  }
}

export default connect(state => {
  return {
    user: state.user.user
  }
})(withRouter(EnsureULSession))



// WEBPACK FOOTER //
// ./src/components/EnsureULSession.js